import { genericJourneyResolverMapping } from '@dxb-web-ui-framework/mocks/msw/types';
import { genericMapToHandlers } from '@dxb-web-ui-framework/mocks/msw/utils/genericMapToHandlers';
import { ecommbx } from '../../index';

const activityLogMap: genericJourneyResolverMapping[] = [
  { url: /\/api\/private\/activity-log\/\d+\/details/, response: () => ecommbx.activityLogDetailsData, method: 'get' },
  { url: /\/api\/private\/activity-log/, response: () => ecommbx.activityLogListData, method: 'get' },
];

const activityLogHandlers = activityLogMap.map(genericMapToHandlers);

export { activityLogHandlers };
